// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardCompletedStatusCard_root__UAt0m","text":"PlasmicDashboardCompletedStatusCard_text__GU6mE"};